import { Create } from 'react-admin';
import { AccordionForm } from '@react-admin/ra-form-layout';
import { ReactElement } from 'react';
import { BidResource } from '../../Entities/Bid';
import EditToolbar from '../../Components/EditToolbar';
import ApprovalDetailsSection from './Form/Create/ApprovalDetailsSection';
import BidStatusSection from './Form/BidStatusSection';
import OfferDetailsSection from './Form/Create/OfferDetailsSection';
import GetPriceDetailsSection from './Form/GetPriceDetailsSection';

export default function BidCreate(): ReactElement {
  return (
    <Create<BidResource>>
      <AccordionForm toolbar={<EditToolbar />}>
        <ApprovalDetailsSection label="Approval status/details" />
        <BidStatusSection label="Bid status" />
        <OfferDetailsSection label="Offer details" />
        <GetPriceDetailsSection label="GetPrice details" />
      </AccordionForm>
    </Create>
  );
}
